import {z} from 'zod'
import {emptyStringToNull} from '@/validation-utils/ZodHelpers'

export const ContactInfoSchema = z.object({
    name: z.union([
        z.literal(''),
        z.string()
    ]),
    email: emptyStringToNull(z.email('Epost må være gyldig')),
    phoneNumber: emptyStringToNull(z.string('Telefonnummer må være satt').trim().min(2, 'Minimumslengde på telefonnummer er 2'))
})

export type ContactInfo = z.infer<typeof ContactInfoSchema>
